import { ProductResponse } from '@/types/product'
import { useRouter } from 'next/navigation'

interface ProductItemProps {
  data: ProductResponse
}

export default function ProductItem({ data }: ProductItemProps) {
  const router = useRouter()
  const hasDiscount = data.regularPrice > data.price
  const onDetailClick = () => {
    router.push(`/san-pham?product_id=${data.customId}`)
  }

  return (
    <div
      onClick={onDetailClick}
      className="group relative flex flex-col bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-blue-200 transition-all duration-500 hover:shadow-2xl hover:shadow-blue-500/10 cursor-pointer h-full"
    >
      <div className="relative w-full h-48 overflow-hidden bg-gray-50">
        <img
          src={data.imageUrl}
          alt={data.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {(() => {
          if (!hasDiscount) return null
          const discountPercent = Math.round(((data.regularPrice - data.price) / data.regularPrice) * 100)
          return (
            <div
              className={`absolute top-3 left-3 bg-gray-900 text-white text-[11px] font-extrabold px-2 py-1 rounded-lg shadow-lg shadow-black/30 ${
                discountPercent > 30 ? 'animate-deal-pulse' : ''
              }`}
            >
              -{discountPercent}%
            </div>
          )
        })()}
      </div>

      {/* Product Info */}
      <div className="p-4 flex flex-col grow space-y-2">
        {data.brandName && (
          <p className="text-xs font-semibold uppercase tracking-wide text-blue-600">{data.brandName}</p>
        )}

        <h3 className="font-bold text-gray-900 line-clamp-2 text-sm leading-tight group-hover:text-blue-600 transition-colors h-9">
          {data.title}
        </h3>

        <div className="pt-2 mt-auto">
          <div className="flex items-baseline gap-2 flex-wrap">
            <div className="flex items-baseline gap-0.5">
              <span className="text-lg font-black text-red-600 tracking-tight">
                {data.price.toLocaleString('vi-VN')}
              </span>
              <span className="text-xs font-bold text-red-600">đ</span>
            </div>
            {hasDiscount && (
              <span className="text-[13px] text-gray-400 line-through">
                {data.regularPrice.toLocaleString('vi-VN')}đ
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
